import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';

@Component({
  selector: 'app-toggle-sms-internet-plus',
  templateUrl: './toggle-sms-internet-plus.component.html',
  styleUrls: ['./toggle-sms-internet-plus.component.css'],
  standalone: false
})
export class ToggleSmsInternetPlusComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  blockStatus: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
    if (this.line.optionsStatus.blocking_multimedia_purchase === 'blocking_in_progress' || this.line.optionsStatus.blocking_multimedia_purchase === true) {
      this.blockStatus = true;
    } else if (this.line.optionsStatus.blocking_multimedia_purchase === 'unblocking_in_progress' || this.line.optionsStatus.blocking_multimedia_purchase === false) {
      this.blockStatus = false;
    } else {
      this.blockStatus = true;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({
        step: 1,
        active: this.blockStatus,
        phoneNumber: this.line.phoneNumber
      }, this.procedureCode));
    }
  }
}
